__webpack_require__.p = "https://assets.socrative.com/5.2.0/js/";